import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=53bbe3c4"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=53bbe3c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports